import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';
import { styles } from './TableCellSpinner.styles';
import locale from './customReports-locale.json';

export function TableCellSpinner() {
  return (
    <Box sx={styles.spinnerContainer}>
      <CircularProgress size={16} thickness={5} sx={styles.spinner} /> {locale.statusCell.updating}
    </Box>
  );
}
